export function HotelPhotoDots({
  count,
  current,
}: {
  readonly count: number;
  readonly current: number;
}) {
  if (count < 2) return null;

  return (
    <span className="flex gap-1" aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <i
          key={index}
          className={
            index === current
              ? 'size-1.5 rounded-full bg-white'
              : 'size-1.5 rounded-full bg-white/50'
          }
        />
      ))}
    </span>
  );
}
